import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import avatar from './user-avatar.png';
import UserAvatar from './user-avatar.jsx';
import styles from './user-login.css';

const loginedUser = (username) => (
    <React.Fragment>
        <UserAvatar
            className={styles.avatar}
            imageUrl={avatar}
        />
        <span className={styles.profileName}>
            {username}
        </span>
    </React.Fragment>
);

const loginingUser = (loginHandle) => {
    return (
        <div onClick={() => loginHandle()} >
            <FormattedMessage defaultMessage="登入" description="登入" id="gui.menuBar.login" />
        </div>
    )
}


const UserLogin = ({ className, isLogin, username, loginHandle }) => (
    <div
        className={classNames(className, styles.login)}
    >
        {isLogin ? loginedUser(username) : loginingUser(loginHandle)}
    </div>
)

UserLogin.propTypes = {
    className: PropTypes.string,
    isLogin: PropTypes.bool,
    username: PropTypes.string,
    loginHandle: PropTypes.func
}

export default UserLogin;
